import { BASE_URL, HTTP_METHODS } from "../App/Configs/AppConfigs";
import ApiHelper from "../App/Utils/ApiHelper";

export class DataProvider {
  apiHelper = new ApiHelper(BASE_URL + "/claim/");
  
  masterApiHelper = new ApiHelper(BASE_URL + "/master");

  getContractValuesforDropdown = async (value) => {
    const url = value
      ? `contract/?${value}`
      : "contract/?page=1&pageSize=10";
    return await this.apiHelper.apiCall(url, HTTP_METHODS.GET, null);
  };

  newContractCreate = async (payload, multipart=false) => {
    return await this.apiHelper.apiCall(
      "contract/",
      HTTP_METHODS.POST,
      payload,
      multipart
    );
  };

  getDropdownValues = async (model, value) => {
    const url = value
      ? "/masters." +
        model +
        "/list?is_active=True&filter=1&page=1&pageSize=100&" +
        value
      : "/masters." +
        model +
        "/list?is_active=True&filter=1&page=1&pageSize=100";
    return await this.masterApiHelper.apiCall(url, HTTP_METHODS.GET, null);
  };

  getSpecificValue = async (model, value) => {
    const url = "/masters." + model + "/" + value;
    return await this.masterApiHelper.apiCall(url, HTTP_METHODS.GET, null);
  };

  getClaimList = async (value) => {
    const url = "/contract/";
  };

  newDiscussionCreate = async (payload) => {
    return await this.apiHelper.apiCall(
      "discussion/",
      HTTP_METHODS.POST,
      payload
    );
  };

  getDiscussions = async (value) => {
    return await this.apiHelper.apiCall(
      "discussion/?id=" + value,
      HTTP_METHODS.GET,
      null
    );
  };

  downloadFile = async (model, filename) => {
    let url = `${model}/?${filename}`
    return await this.apiHelper.apiCall( url, HTTP_METHODS.GET, null);
  };

  getContractDataBasedOnStatus = async (value) => {
    return await this.apiHelper.apiCall(
      "discussion/?status=" + value,
      HTTP_METHODS.GET,
      null
    );
  };
}
